import React from 'react';
import {Link} from 'react-router-dom';
import axios from 'axios';
import Cookies from 'js-cookie';
import Header from './Header';
class Home extends React.Component {
  constructor(props) {
      super(props);
      this.state = {
        value: 0,
          result: null,
          error: false,
          isLoading: false,
          lclassName  : 'login123',
          hclassName  : 'home124',
          access_tokenex : "",
          topNews:[],
          topNewsw:[],
          topNewsx:[],
          topNewsy:[],
          topNewsz:[],
          happenings:[],
          awards:[],
          chairmanmsg:[],
          dirmsg:[],
          qoutes:[]
      }
    }
  componentDidMount() {
    var access_token = localStorage.getItem("access_token");
    const authstatus = localStorage.getItem("authstatus");
    Cookies.set('access_token', access_token, { expires: 7 });
    console.log(access_token);
    var app = localStorage.getItem("appid");
    
    axios.get('https://api.indianoilxpress.com/MobService.svc/auth/'+app+"/"+access_token)
      .then(({data} )=> { 
        this.setState({authData:data.authResult[0]});
        if (this.state.authData.status === 'VALID'){
          console.log(this.state.authData.status)
          localStorage.setItem("access_token", access_token);
          localStorage.setItem("authstatus", this.state.authData.status);
          this.setState({isLoading: true});
          this.setState({
            lclassName:'login124',
            hclassName:'home123',
            access_tokenex:access_token,
          });
        }
    });
    if (authstatus === 'VALID'){
      this.setState({
        lclassName:'login124',
        hclassName:'home123',
        access_tokenex:access_token,
      });
    }
    else{
      this.setState({
        lclassName:'login123',
        hclassName:'home124',
        access_tokenex:access_token,
      });
    }
     axios.get('https://api.indianoilxpress.com/MobService.svc/Topnews/')   
      .then(({data} )=> {
        this.setState({topNews:data.TopNewsSResult[0]});
        this.setState({topNewsw:data.TopNewsSResult[1]});
        this.setState({topNewsx:data.TopNewsSResult[2]});
        this.setState({topNewsy:data.TopNewsSResult[3]});
        this.setState({topNewsz:data.TopNewsSResult[4]});
      });
      axios.get('https://api.indianoilxpress.com/MobService.svc/Happenings')
      .then(({data} )=> {
        const happenings = data.HappeningsSResult
        this.setState({happenings});
      });
      axios.get('https://api.indianoilxpress.com/MobService.svc/awards')
      .then(({data} )=> {
        const awards = data.awardsRResult
        this.setState({awards});
      });
      axios.get('https://api.indianoilxpress.com/MobService.svc/chairmanmessage')
      .then(({data} )=> {
        const chairmanmsg = data.ChairmanmessageRResult
        this.setState({chairmanmsg});
      });
      axios.get('https://api.indianoilxpress.com/MobService.svc/directormessage')
      .then(({data} )=> {
        const dirmsg = data.DirectormessageRResult
        this.setState({dirmsg});
      });
      axios.get('https://api.indianoilxpress.com/MobService.svc/quotation')
      .then(({data} )=> {
        const qoutes = data.QuotationResult[0]
        this.setState({qoutes});
      });
    }
  render() {
    const ak = this.state.access_tokenex
    sessionStorage.setItem("ak", ak);
    return (
      
      <div>
        <div className={this.state.lclassName}>
          <div className="root123">
            <div className="container12">
              <div className="topline"></div>
              <img className="xpresslogo" src="/icons/android-icon-72x72.png" alt="XPRESSLite"/>
              <div className="isResponsive" ><p>
                <span className="st21">XPRESS</span><span className="st11">Lite</span><br/>
                </p>
                <div className="content">
                  <p style={{ fontSize: '18px', textAlign: 'center', color:'#00154D',padding: '20px',}}><span>Welcome to</span><br/><b>IndianOilXpress</b> <br/>For IndianOilPeople</p>
                  
                  <a href="https://xsparsh.indianoil.in/IOCLEmpAuth/?app=22011989" className="abutton">Click here to login</a>
                </div>
              </div>
              <div id="fakeLoader"></div>
              <div style={{position:'absolute', width:'100%', bottom:'0',}}>
                <img className="ioclogo" src="\img\ioclogo.png" alt="IndianOil"/><br/>
                <div className="botmline12"></div>
                <div className="botmline13"></div>
              </div>
            </div>
          </div>
        </div>
        <div className={this.state.hclassName}>
         <Header /> 

         <div className="xpressNews"><a href="https://indianoilxpress.com/uploads/XpressNews/XpressNews_23_January_2024.pdf"><img src='https://iocl.com/uploads/XpressNews/Banner/2025/Thursday.jpg' alt='Xpress News' /></a></div>
       
          <div className="slider">
            <ul className="slides">
              <li>
                <Link to={{ pathname: '/news', query:{newsId: this.state.topNews.Newsid } }} ><img src={this.state.topNews.newsimagepath} alt="IndianOil Xpress"/>
                <div className="caption slider-content  left-aligh">
                  <h2>{this.state.topNews.Newstitle}</h2>
                  <div className="date">{this.state.topNews.Newsdate}</div>
                </div></Link>
              </li>
              <li>
                <Link to={{ pathname: '/news', query:{newsId: this.state.topNewsw.Newsid } }} ><img src={this.state.topNewsw.newsimagepath} alt="IndianOil Xpress"/>
                <div className="caption slider-content  left-aligh">
                  <h2>{this.state.topNewsw.Newstitle}</h2>
                  <div className="date">{this.state.topNewsw.Newsdate}</div>
                </div></Link>
              </li>
              <li>
                <Link to={{ pathname: '/news', query:{newsId: this.state.topNewsx.Newsid } }} ><img src={this.state.topNewsx.newsimagepath} alt="IndianOil Xpress"/>
                <div className="caption slider-content  left-aligh">
                  <h2>{this.state.topNewsx.Newstitle}</h2>
                  <div className="date">{this.state.topNewsx.Newsdate}</div>
                </div></Link>
              </li>

              <li>
                <Link to={{ pathname: '/news', query:{newsId: this.state.topNewsy.Newsid } }} ><img src={this.state.topNewsy.newsimagepath} alt="IndianOil Xpress"/>
                <div className="caption slider-content  left-aligh">
                  <h2>{this.state.topNewsy.Newstitle}</h2>
                  <div className="date">{this.state.topNewsy.Newsdate}</div>
                </div></Link>
              </li>
              <li>
                <Link to={{ pathname: '/news', query:{newsId: this.state.topNewsz.Newsid } }} ><img src={this.state.topNewsz.newsimagepath} alt="IndianOil Xpress"/>
                <div className="caption slider-content  left-aligh">
                  <h2>{this.state.topNewsz.Newstitle}</h2>
                  <div className="date">{this.state.topNewsz.Newsdate}</div>
                </div></Link>
              </li>
              
            </ul>
          </div>
    

          {/* <div class="testimonial"><div class="container" style={{ width: '100%'}}><a href="/messageChairman"><img src="https://iocl.com/uploads/ioclxpress/Chairman_Messages/Chairman_Quate_bannerNew.jpg" alt="Straight talk" style={{ borderRadius: '0', width: '100%', height: "auto", margin: "0px auto", display: "block"}} /> </a> </div></div> */}
          <div class="testimonial"><div class="container" style={{ width: '100%'}}><img src="https://iocl.com/uploads/ioclxpress/Chairman_Messages/Chairman_Quate_bannerNew.jpg" alt="Straight talk" style={{ borderRadius: '0', width: '100%', height: "auto", margin: "0px auto", display: "block"}} /></div></div>
          <div className="latest-new">
            <div className="head">
              <h5>Latest News</h5>
            </div>
            <div className="container">
              { this.state.happenings.map(happenings =>
              <div key={happenings.Newsid}>
              <div className="row" style={{ borderBottom : '1px solid', borderBottomColor: '#d0cfce'}}>
                <Link to={{ pathname: '/news', query:{newsId: happenings.Newsid } }} >
                <div className="col s5">
                  <img src={happenings.Newsthumb} alt="IndianOil Xpress"/>
                </div>
                <div className="col s7">
                  <h6><span>{happenings.Newstitle}</span></h6>
                </div>
                </Link>
              </div>
                
              </div>
              )}
            </div>
          </div>
          <div className="latest-new">
          <div className="head">
            <h5>Awards & Recognitions </h5>
          </div>
          <div className="container">
            { this.state.awards.map(awards =>
              <div key={awards.Newsid}>
                <div className="row" style={{ borderBottom : '1px solid', borderBottomColor: '#d0cfce'}}>
                  <Link to={{ pathname: '/news', query:{newsId: awards.Newsid } }} >
                    <div className="col s5">
                      <img src={awards.Newsthumb} alt="IndianOilXpress"/>
                    </div>
                    <div className="col s7">
                      <h6><span>{awards.Newstitle}</span></h6>
                    </div>
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="latest-new">
          <div className="head">
            <h5>Chairman's Messages</h5>
          </div>
          <div className="container">
            { this.state.chairmanmsg.map(chairmanmsg =>
              <div key={chairmanmsg.Newsid}>
                <div className="row" style={{ borderBottom : '1px solid', borderBottomColor: '#d0cfce'}}>
                  <Link to={{ pathname: '/news', query:{newsId: chairmanmsg.Newsid } }} >
                    <div className="col s5">
                      <img src={chairmanmsg.Newsthumb} alt="IndianOil Xpress"/>
                    </div>
                    <div className="col s7">
                      <h6><span>{chairmanmsg.Newstitle}</span></h6>
                    </div>
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="latest-new">
          <div className="head">
            <h5>Directors' Messages</h5>
          </div>
          <div className="container">
            { this.state.dirmsg.map(dirmsg =>
              <div key={dirmsg.Newsid}>
                <div className="row" style={{ borderBottom : '1px solid', borderBottomColor: '#d0cfce'}}>
                  <Link to={{ pathname: '/news', query:{newsId: dirmsg.Newsid } }} >
                    <div className="col s5">
                      <img src={dirmsg.Newsthumb} alt="IndianOil Xpress"/>
                    </div>
                    <div className="col s7">
                      <h6><span>{dirmsg.Newstitle}</span></h6>
                    </div>
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
      
          <div id="fakeLoader"></div>
          <div className="footer">
            <div className="container">
            <div className="copyright">
							<span>Copyright © IndianOilXpress</span><br/>
							<a href="https://www.facebook.com/IndianOilCorpLimited" target="_blank"><i class="fab fa-facebook-f"></i></a>
                <a href="https://twitter.com/indianOilcl" target="_blank"><i class="fab fa-twitter"></i></a>
                <a href="https://www.youtube.com/channel/UC5ho18VZHwEFSahW0Q_o-6g/feed" target="_blank"><i class="fab fa-youtube"></i></a>
				<a href="https://www.instagram.com/indianoilcorp" target="_blank"><i class="fab fa-instagram"></i></a>
				<a href="https://www.linkedin.com/company/indian-oil-corp-limited" target="_blank"><i class="fab fa-linkedin-in"></i></a>
				
						</div>
            </div>
          </div>
        </div>
      </div>
    );
  
  }
}
export default Home;


// WEBPACK FOOTER //
// ./src/Authnicate.js